// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-result__result {
    display: flex;
    justify-content: space-between;
    height: 83px;
    align-items: center;
    margin: 0 16px;
    padding: 16px 0;
    background: var(--white-color);
    /* border-bottom: 1px solid var(--new-gray-background-color); */
    border-top: 1px solid var(--new-gray-background-color);
}

/* .search-result {
    margin-top: var(--space-x2);
} */

.search-result__result__subtitle{
    color : var(--basic-gray-color) !important;  
}

.search-result__cat-personas__options{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 16px;
}

.search-result__cat-personas{   
    margin: 16px 0;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
}

.search-result__cat-personas .baloa-subtitle-2{
    color: var(--primary-very-dark-color);
}

.search-result__cat-personas a .baloa-subtitle-2 {
    color: var(--new-green-color);
    font-weight: 500;
}

.search-result__result__searchtitle{
    text-transform: capitalize;
    margin-top: var(--space);
}

.search-result__result__profile-info__post{
    margin-left: 10px;
    margin-top: var(--space);
}


.search-result__result__catbuttons{
    padding: var(--space-x2) 0;
    display: flex;
}

.search-result__result__catbutton-button{
    border-radius: var(--space-and-half);
    margin-right: var(--space-half);
    border: 2px solid var(--new-green-color);
    color: var(--new-green-color);
}

.search-result__result__catbutton-button:hover{
    background-color: var(--new-green-color);
    border: 2px solid var(--new-green-color);
    color: var(--white-color);
}

.search-result__result__catbutton-button.active{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.search-result__result__profile-info {
    display: flex;
    align-items: center;
}

.search-result__result__profile-info__photo {
    width: 46px;
    height: 46px;
    /* min-width: var(--space-x2-and-half);
    min-height: var(--space-x2-and-half); */
    margin-right: var(--space-half);
    border-radius: 50%;
    /* overflow: hidden;
    position: relative; */
    margin-left: var(--space-half);
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-result__result__profile-info__photo .icon-ball{
    font-size: 36px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-result__result__profile-info__photo img {
    width: 46px;
    height: 46px;
    border-radius: 50%;
}

.search-result__result_post {
    display: flex;
    /* justify-content: space-between; */
    width: 100%;
    /* height: 83px; */
    align-items: center;
    /* margin: 0 auto; */
    margin-bottom: var(--space-half);
    padding: var(--space-half);
    background: var(--white-color);
    border-radius: 12px;
}

.search-result__result__post__photo {
    width: 150px;
    height: 100px;
    background: #CCC;
    overflow: hidden;
    border-radius: 7px;
    margin-right: var(--space);
}

.search-result__result__post__photo img {
    width: 100%;
    height: 100%;
}

.search-result__result__profile-info__data {
    display: flex;
    flex-direction: column;
    margin-right: var(--space-half);
}

.search-result__result__profile-info__data .baloa-username {
    color: var(--basic-gray-color);
}

.search-result__result__profile-info__data .baloa-names {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
}

.search-result__result__follow-button button{
    padding: 8px 12px;
    border-radius: 5px;
}

.search-result__result__follow-button .icon {
    grid-area: icon;
    font-size: 19px;
}

.search-result__result__follow-button .secondary-button.following{
    background: #E6F6EC;
    color: var(--new-green-color);
}

.search-result__result__follow-button .secondary-button.following:focus{
    color: var(--new-green-color);
    background: #E6F6EC;
}

.search-result__result__follow-button .secondary-button:focus{
    color: var(--new-green-color);
    background-color: var(--white-color);
    border: 1px solid var(--new-green-color);
}

.search-result__cat-personas.filtered{
    margin: 16px 0;
    border-radius: 0;
    border: none;
    background: transparent;
}

.search-result__cat-personas__buttons.filtered {
    display: flex;
    align-items: center;
    padding: 0;
    gap: 8px;
}

.search-result__result.filtered{

    height: 83px;
    margin: 12px 0;
    padding: 16px;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 6px;
}

.search-result__result.tournament {
    height: auto;
    margin: 12px 0;
    padding: 12px;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 6px;
}

.search-result__result__tournament-info {
    display: flex;
    position: relative;
}

.search-result__result__profile-info__tournament-photo{
    border-radius: 7px;
    width: 240px;
    height: 130px;
    margin-right: 12px;
}

.search-result__result__profile-info__tournament-photo-img{
    border-radius: 7px;
    width: 240px;
    height: 130px;
    object-fit: cover;    
}

.search-result__result__profile-info__tournament-labels-container {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: inherit;
    align-items: flex-start;
    height: inherit;
    padding: 8px;
    top: 0;
}

.search-result__result__profile-info__tournament-labels-container__label {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    height: 100%;
}

.search-result__result__profile-info__tournament-labels-container__label .baloa-table-column{
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    color: var(--white-color);
}
/*Registration Open*/
.search-result__result__profile-info__tournament-labels-container__label .Registration_Open {
    background-color: #3078B3;
}
/*Scheduled*/
.search-result__result__profile-info__tournament-labels-container__label .Scheduled,
.search-result__result__profile-info__tournament-labels-container__label .Started,
.search-result__result__profile-info__tournament-labels-container__label .Registration_Closed  {
    background-color: var(--new-green-color);
}
/*Finalized*/
.search-result__result__profile-info__tournament-labels-container__label .Finalized {
    background-color: var(--basic-gray-color);
}


.search-result__result__tournament-data {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.search-result__result__tournament-data__image{
    width: 35px;
    height: 35px;
    margin-right: 7px;
    justify-content: center;
    align-items: center;
}

.search-result__result__tournament-data__image img{
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.search-result__result__tournament-data__image .icon-ball{
    font-size: 29px;
    padding: 3px;
    color: var(--white-color);
    border-radius: 50%;
}

.search-result__result__location {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 8px;
}

.search-result__result__location.baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.search-result__result__location .hubicon-location {
    font-size: 22px;
}

.search-result__result__location .hubicon-location::before {
    color: var(--primary-dark-color);
}

.search-result__result__tournament-page-data__image{
    width: 22px;
    height: 22px;
    margin-right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.search-result__result__tournament-page-data__image img{
    width: 22px;
    height: 22px;
    border-radius: 50%;
}

.search-result__result__tournament-page-data__image .icon-ball{
    font-size: 18px;
    padding: 2px;
    color: var(--white-color);
    border-radius: 50%;
}

.search-result__result__team-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.search-result__result__team-data {
    display: flex;
    align-items: center;
}

.search-result__result__location.teamsearch {
    margin-top: 0;
}

.search-result__result__data-tags .hubicon-roles_fill{
    font-size: 22px;
    margin-right: 4px;
    margin-left: 8px;
}

.search-result__result__data-tags .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.search-result__empty {
    padding: 100px 0;
    text-align: center;
}

.search-result__empty .baloa-normal-medium {
    margin-top: 30px;
    color: var(--primary-dark-color);
}

/* Small */

.profile-suggestions.sm .search-result__result {
    background-color: var(--white-color);
    flex-direction: column;
    padding: var(--space);
    border-radius: 4px;
    box-shadow: var(--shadow-card-1);
    width: 100%;
    margin-bottom: var(--space);
}
.profile-suggestions.sm .search-result__result__profile-info {
    align-self: flex-start;
    align-items: flex-start;
}
.profile-suggestions.sm .search-result__result__profile-info__photo {
    border-radius: 8px;
}
.profile-suggestions.sm .search-result__result__profile-info__data__fullname {
    display: none;
}
.profile-suggestions.sm .search-result__result__profile-info__data__username {
    font-size: var(--font-small);
    letter-spacing: 0.004em;
    font-weight: var(--font-bold) !important;
}
.profile-suggestions.sm .search-result__result__follow-button {
    margin-top: var(--space-quarter);
    align-self: flex-end;
}

/* Mobile */

.profile-suggestions.mv .search-result__result {
    flex-direction: column;
    align-content: center;
}

.profile-suggestions.mv .search-result__result__profile-info {
    flex-direction: column;
    align-self: auto;
    align-items: center;
}

.profile-suggestions.mv .search-result__result__profile-info__photo {
    margin: 0;
}

.profile-suggestions.mv .search-result__result__profile-info__data {
    margin: 0;
}

.profile-suggestions.mv .search-result__result__follow-button {
    align-self: auto;
}

.search-result__result__data-tags{
/*     font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: 11px;
    line-height: 13px; */
    padding-top: 2px;
    display: flex;
    align-items: center;
}

.search-result__result__data-tag{
    border-radius: 25px;
    padding: 2px 6px;
    margin-right: 4px;
    color: var(--primary-dark-color);
    border: 1px solid var(--new-gray-border-color);
    background: var(--new-grey-light-background-color);
}

.search-result__result__data-tag.baloa-username {
    color: var(--primary-dark-color);
}

.search-result__result__data-tag.baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.search-result__result__data-tag__green{
    background: var(--new-green-color);
    border-radius: 25px;
    padding: 2px 6px;
    margin-right: 4px;
    color: var(--white-color);
}

.search-result__cat-personas__buttons{
    display: flex;
    align-items: center;
    padding: 8px 12px;
    gap: 8px;
}

/* @media screen and ( max-width: 576px ) {
    
    .search-result__result {
        width: 100%;
    }

}
 */
@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .search-result__result__catbuttons .button.small {
        padding: 8px;
        white-space: nowrap;
    }
    .search-result__result__catbuttons {
        overflow-y: scroll;
    }
    .search-result {
        padding-top: var(--space-x3);
    }

    .search-result__cat-personas {
        margin: 10px 0;
        border: none;
        border-radius: unset;
    }

    .search-result__result {
        padding: 12px 0;
        margin: 0 12px;
    }

    .search-result__result.filtered {
        padding: 12px;
        margin: 8px 0;
    }

    .search-result__cat-personas.filtered {
        padding: 10px 0;
    }

    .search-result__result__profile-info__photo {
        width: 35px;
        height: 35px;
        margin-left: 0;
    }

    .search-result__result__profile-info__photo img {
        width: 35px;
        height: 35px;
    }

    .search-result__result__profile-info__photo .icon-ball {
        font-size: 29px;
        padding: 3px;
    }

    .search-result__result.tournament {
        padding: 8px;
        margin: 8px 0;
    }

    .search-result__result__profile-info__tournament-photo {
        width: 120px;
        height: 80px;
        margin-right: 8px;
    }
    .search-result__result__profile-info__tournament-photo-img {
        width: 120px;
        height: 80px;
    }

    .search-result__result__tournament-data__image {
        width: 28px;
        height: 28px;
        margin-right: 4px;
    }

    .search-result__result__tournament-data__image img {
        width: 28px;
        height: 28px;
    }

    .search-result__result__tournament-data__image .icon-ball {
        font-size: 24px;
        padding: 2px;
    }

    .search-result__result__location {
        margin-top: 4px;
    }

    .search-result__result__location .hubicon-location {
        font-size: 12px;
    }

    .search-result__result__tournament-page-data__image {
        width: 12px;
        height: 12px;
    }

    .search-result__result__tournament-page-data__image img {
        width: 12px;
        height: 12px;
    }

    .search-result__result__team-info {
        gap: 8px;
    }

    .teamsearch .search-result__result__tournament-page-data__image {
        width: 20px;
        height: 20px;
    }

    .teamsearch .search-result__result__tournament-page-data__image img{
        width: 20px;
        height: 20px;
    }

    .teamsearch .search-result__result__tournament-page-data__image .icon-ball {
        font-size: 16px;
        padding: 2px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/search/components/search-result/SearchResultComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,+DAA+D;IAC/D,sDAAsD;AAC1D;;AAEA;;GAEG;;AAEH;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;;AAGA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;2CACuC;IACvC,+BAA+B;IAC/B,kBAAkB;IAClB;yBACqB;IACrB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;AAC7B;AACA,oBAAoB;AACpB;IACI,yBAAyB;AAC7B;AACA,YAAY;AACZ;;;IAGI,wCAAwC;AAC5C;AACA,YAAY;AACZ;IACI,yCAAyC;AAC7C;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,UAAU;;AAEV;IACI,oCAAoC;IACpC,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,wCAAwC;AAC5C;AACA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA,WAAW;;AAEX;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;AACA;;;;wBAIwB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,8CAA8C;IAC9C,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;;;;;;;EAOE;AACF,yCAAyC,4BAA4B;IACjE;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,4BAA4B;IAChC;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ","sourcesContent":[".search-result__result {\n    display: flex;\n    justify-content: space-between;\n    height: 83px;\n    align-items: center;\n    margin: 0 16px;\n    padding: 16px 0;\n    background: var(--white-color);\n    /* border-bottom: 1px solid var(--new-gray-background-color); */\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n/* .search-result {\n    margin-top: var(--space-x2);\n} */\n\n.search-result__result__subtitle{\n    color : var(--basic-gray-color) !important;  \n}\n\n.search-result__cat-personas__options{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 12px 16px;\n}\n\n.search-result__cat-personas{   \n    margin: 16px 0;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n}\n\n.search-result__cat-personas .baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n}\n\n.search-result__cat-personas a .baloa-subtitle-2 {\n    color: var(--new-green-color);\n    font-weight: 500;\n}\n\n.search-result__result__searchtitle{\n    text-transform: capitalize;\n    margin-top: var(--space);\n}\n\n.search-result__result__profile-info__post{\n    margin-left: 10px;\n    margin-top: var(--space);\n}\n\n\n.search-result__result__catbuttons{\n    padding: var(--space-x2) 0;\n    display: flex;\n}\n\n.search-result__result__catbutton-button{\n    border-radius: var(--space-and-half);\n    margin-right: var(--space-half);\n    border: 2px solid var(--new-green-color);\n    color: var(--new-green-color);\n}\n\n.search-result__result__catbutton-button:hover{\n    background-color: var(--new-green-color);\n    border: 2px solid var(--new-green-color);\n    color: var(--white-color);\n}\n\n.search-result__result__catbutton-button.active{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.search-result__result__profile-info {\n    display: flex;\n    align-items: center;\n}\n\n.search-result__result__profile-info__photo {\n    width: 46px;\n    height: 46px;\n    /* min-width: var(--space-x2-and-half);\n    min-height: var(--space-x2-and-half); */\n    margin-right: var(--space-half);\n    border-radius: 50%;\n    /* overflow: hidden;\n    position: relative; */\n    margin-left: var(--space-half);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.search-result__result__profile-info__photo .icon-ball{\n    font-size: 36px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.search-result__result__profile-info__photo img {\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n}\n\n.search-result__result_post {\n    display: flex;\n    /* justify-content: space-between; */\n    width: 100%;\n    /* height: 83px; */\n    align-items: center;\n    /* margin: 0 auto; */\n    margin-bottom: var(--space-half);\n    padding: var(--space-half);\n    background: var(--white-color);\n    border-radius: 12px;\n}\n\n.search-result__result__post__photo {\n    width: 150px;\n    height: 100px;\n    background: #CCC;\n    overflow: hidden;\n    border-radius: 7px;\n    margin-right: var(--space);\n}\n\n.search-result__result__post__photo img {\n    width: 100%;\n    height: 100%;\n}\n\n.search-result__result__profile-info__data {\n    display: flex;\n    flex-direction: column;\n    margin-right: var(--space-half);\n}\n\n.search-result__result__profile-info__data .baloa-username {\n    color: var(--basic-gray-color);\n}\n\n.search-result__result__profile-info__data .baloa-names {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.search-result__result__follow-button button{\n    padding: 8px 12px;\n    border-radius: 5px;\n}\n\n.search-result__result__follow-button .icon {\n    grid-area: icon;\n    font-size: 19px;\n}\n\n.search-result__result__follow-button .secondary-button.following{\n    background: #E6F6EC;\n    color: var(--new-green-color);\n}\n\n.search-result__result__follow-button .secondary-button.following:focus{\n    color: var(--new-green-color);\n    background: #E6F6EC;\n}\n\n.search-result__result__follow-button .secondary-button:focus{\n    color: var(--new-green-color);\n    background-color: var(--white-color);\n    border: 1px solid var(--new-green-color);\n}\n\n.search-result__cat-personas.filtered{\n    margin: 16px 0;\n    border-radius: 0;\n    border: none;\n    background: transparent;\n}\n\n.search-result__cat-personas__buttons.filtered {\n    display: flex;\n    align-items: center;\n    padding: 0;\n    gap: 8px;\n}\n\n.search-result__result.filtered{\n\n    height: 83px;\n    margin: 12px 0;\n    padding: 16px;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 6px;\n}\n\n.search-result__result.tournament {\n    height: auto;\n    margin: 12px 0;\n    padding: 12px;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 6px;\n}\n\n.search-result__result__tournament-info {\n    display: flex;\n    position: relative;\n}\n\n.search-result__result__profile-info__tournament-photo{\n    border-radius: 7px;\n    width: 240px;\n    height: 130px;\n    margin-right: 12px;\n}\n\n.search-result__result__profile-info__tournament-photo-img{\n    border-radius: 7px;\n    width: 240px;\n    height: 130px;\n    object-fit: cover;    \n}\n\n.search-result__result__profile-info__tournament-labels-container {\n    position: absolute;\n    display: flex;\n    justify-content: space-between;\n    width: inherit;\n    align-items: flex-start;\n    height: inherit;\n    padding: 8px;\n    top: 0;\n}\n\n.search-result__result__profile-info__tournament-labels-container__label {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n}\n\n.search-result__result__profile-info__tournament-labels-container__label .baloa-table-column{\n    padding: 5px 10px;\n    border-radius: 4px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);\n    color: var(--white-color);\n}\n/*Registration Open*/\n.search-result__result__profile-info__tournament-labels-container__label .Registration_Open {\n    background-color: #3078B3;\n}\n/*Scheduled*/\n.search-result__result__profile-info__tournament-labels-container__label .Scheduled,\n.search-result__result__profile-info__tournament-labels-container__label .Started,\n.search-result__result__profile-info__tournament-labels-container__label .Registration_Closed  {\n    background-color: var(--new-green-color);\n}\n/*Finalized*/\n.search-result__result__profile-info__tournament-labels-container__label .Finalized {\n    background-color: var(--basic-gray-color);\n}\n\n\n.search-result__result__tournament-data {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.search-result__result__tournament-data__image{\n    width: 35px;\n    height: 35px;\n    margin-right: 7px;\n    justify-content: center;\n    align-items: center;\n}\n\n.search-result__result__tournament-data__image img{\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n}\n\n.search-result__result__tournament-data__image .icon-ball{\n    font-size: 29px;\n    padding: 3px;\n    color: var(--white-color);\n    border-radius: 50%;\n}\n\n.search-result__result__location {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 8px;\n}\n\n.search-result__result__location.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.search-result__result__location .hubicon-location {\n    font-size: 22px;\n}\n\n.search-result__result__location .hubicon-location::before {\n    color: var(--primary-dark-color);\n}\n\n.search-result__result__tournament-page-data__image{\n    width: 22px;\n    height: 22px;\n    margin-right: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.search-result__result__tournament-page-data__image img{\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n}\n\n.search-result__result__tournament-page-data__image .icon-ball{\n    font-size: 18px;\n    padding: 2px;\n    color: var(--white-color);\n    border-radius: 50%;\n}\n\n.search-result__result__team-info {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.search-result__result__team-data {\n    display: flex;\n    align-items: center;\n}\n\n.search-result__result__location.teamsearch {\n    margin-top: 0;\n}\n\n.search-result__result__data-tags .hubicon-roles_fill{\n    font-size: 22px;\n    margin-right: 4px;\n    margin-left: 8px;\n}\n\n.search-result__result__data-tags .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.search-result__empty {\n    padding: 100px 0;\n    text-align: center;\n}\n\n.search-result__empty .baloa-normal-medium {\n    margin-top: 30px;\n    color: var(--primary-dark-color);\n}\n\n/* Small */\n\n.profile-suggestions.sm .search-result__result {\n    background-color: var(--white-color);\n    flex-direction: column;\n    padding: var(--space);\n    border-radius: 4px;\n    box-shadow: var(--shadow-card-1);\n    width: 100%;\n    margin-bottom: var(--space);\n}\n.profile-suggestions.sm .search-result__result__profile-info {\n    align-self: flex-start;\n    align-items: flex-start;\n}\n.profile-suggestions.sm .search-result__result__profile-info__photo {\n    border-radius: 8px;\n}\n.profile-suggestions.sm .search-result__result__profile-info__data__fullname {\n    display: none;\n}\n.profile-suggestions.sm .search-result__result__profile-info__data__username {\n    font-size: var(--font-small);\n    letter-spacing: 0.004em;\n    font-weight: var(--font-bold) !important;\n}\n.profile-suggestions.sm .search-result__result__follow-button {\n    margin-top: var(--space-quarter);\n    align-self: flex-end;\n}\n\n/* Mobile */\n\n.profile-suggestions.mv .search-result__result {\n    flex-direction: column;\n    align-content: center;\n}\n\n.profile-suggestions.mv .search-result__result__profile-info {\n    flex-direction: column;\n    align-self: auto;\n    align-items: center;\n}\n\n.profile-suggestions.mv .search-result__result__profile-info__photo {\n    margin: 0;\n}\n\n.profile-suggestions.mv .search-result__result__profile-info__data {\n    margin: 0;\n}\n\n.profile-suggestions.mv .search-result__result__follow-button {\n    align-self: auto;\n}\n\n.search-result__result__data-tags{\n/*     font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: 11px;\n    line-height: 13px; */\n    padding-top: 2px;\n    display: flex;\n    align-items: center;\n}\n\n.search-result__result__data-tag{\n    border-radius: 25px;\n    padding: 2px 6px;\n    margin-right: 4px;\n    color: var(--primary-dark-color);\n    border: 1px solid var(--new-gray-border-color);\n    background: var(--new-grey-light-background-color);\n}\n\n.search-result__result__data-tag.baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.search-result__result__data-tag.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.search-result__result__data-tag__green{\n    background: var(--new-green-color);\n    border-radius: 25px;\n    padding: 2px 6px;\n    margin-right: 4px;\n    color: var(--white-color);\n}\n\n.search-result__cat-personas__buttons{\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    gap: 8px;\n}\n\n/* @media screen and ( max-width: 576px ) {\n    \n    .search-result__result {\n        width: 100%;\n    }\n\n}\n */\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .search-result__result__catbuttons .button.small {\n        padding: 8px;\n        white-space: nowrap;\n    }\n    .search-result__result__catbuttons {\n        overflow-y: scroll;\n    }\n    .search-result {\n        padding-top: var(--space-x3);\n    }\n\n    .search-result__cat-personas {\n        margin: 10px 0;\n        border: none;\n        border-radius: unset;\n    }\n\n    .search-result__result {\n        padding: 12px 0;\n        margin: 0 12px;\n    }\n\n    .search-result__result.filtered {\n        padding: 12px;\n        margin: 8px 0;\n    }\n\n    .search-result__cat-personas.filtered {\n        padding: 10px 0;\n    }\n\n    .search-result__result__profile-info__photo {\n        width: 35px;\n        height: 35px;\n        margin-left: 0;\n    }\n\n    .search-result__result__profile-info__photo img {\n        width: 35px;\n        height: 35px;\n    }\n\n    .search-result__result__profile-info__photo .icon-ball {\n        font-size: 29px;\n        padding: 3px;\n    }\n\n    .search-result__result.tournament {\n        padding: 8px;\n        margin: 8px 0;\n    }\n\n    .search-result__result__profile-info__tournament-photo {\n        width: 120px;\n        height: 80px;\n        margin-right: 8px;\n    }\n    .search-result__result__profile-info__tournament-photo-img {\n        width: 120px;\n        height: 80px;\n    }\n\n    .search-result__result__tournament-data__image {\n        width: 28px;\n        height: 28px;\n        margin-right: 4px;\n    }\n\n    .search-result__result__tournament-data__image img {\n        width: 28px;\n        height: 28px;\n    }\n\n    .search-result__result__tournament-data__image .icon-ball {\n        font-size: 24px;\n        padding: 2px;\n    }\n\n    .search-result__result__location {\n        margin-top: 4px;\n    }\n\n    .search-result__result__location .hubicon-location {\n        font-size: 12px;\n    }\n\n    .search-result__result__tournament-page-data__image {\n        width: 12px;\n        height: 12px;\n    }\n\n    .search-result__result__tournament-page-data__image img {\n        width: 12px;\n        height: 12px;\n    }\n\n    .search-result__result__team-info {\n        gap: 8px;\n    }\n\n    .teamsearch .search-result__result__tournament-page-data__image {\n        width: 20px;\n        height: 20px;\n    }\n\n    .teamsearch .search-result__result__tournament-page-data__image img{\n        width: 20px;\n        height: 20px;\n    }\n\n    .teamsearch .search-result__result__tournament-page-data__image .icon-ball {\n        font-size: 16px;\n        padding: 2px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
